import PlanFeatures from './plan-features';

import { PlanFeature as PlanFeatureType, PlanOffering } from './plan.types';
import { PlanContainer } from './plan.styles';

export type PlanProps = {
  header: string;
  features: PlanFeatureType[];
  offerings: PlanOffering[];
};

export default function Plan({ header, features, offerings }: PlanProps) {
  return (
    <PlanContainer id="plan">
      <div className="message">
        <h2>{header}</h2>
      </div>
      <PlanFeatures features={features} offerings={offerings} />
    </PlanContainer>
  );
}
